export interface IMapExportPartProps {
  Left?: number
  Top?: number
  WidthMeters?: number
  HeightMeters?: number
  TargetScale?: number
  ProxySettings?: {
    Type: string
    Url: string
    UrlParams: IMapExportPartProxyParams
  }
}

interface IMapExportPartProxyParams {
  Width: number
  Height: number
  DPI: number
  Xmin: number
  Ymin: number
  Xmax: number
  Ymax: number
  Layers: string
}

export interface IRenderImageInfo {
  Page: number
  MapProps?: IMapExportPartProps
  ZIndex: number
  Blob?: Blob
}

export enum PageSize {
  A4 = 'A4',
  A3 = 'A3',
  A2 = 'A2',
  A1 = 'A1',
  A0 = 'A0'
}
